// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import DataTable from "react-data-table-component";
// import * as XLSX from "xlsx";
// import Header from "../components/Header"; // Import Header component

// function Home() {
//   const navigate = useNavigate();
//   const [transactions, setTransactions] = useState([]);
//   const [error, setError] = useState("");
//   const [totalAmount, setTotalAmount] = useState(0);
//   const [filteredTotalAmount, setFilteredTotalAmount] = useState(0);
//   const [searchPaymentType, setSearchPaymentType] = useState("");
//   const [searchStoreName, setSearchStoreName] = useState("");
//   const [filteredTransactions, setFilteredTransactions] = useState([]);

//   useEffect(() => {
//     const fetchTransactions = async () => {
//       try {
//         const token = localStorage.getItem("accessToken");
//         const response = await axios.get("/user/getTransactions", {
//           headers: { Authorization: `Bearer ${token}` },
//         });

//         const fetchedTransactions = response.data.transactions || [];
//         setTransactions(fetchedTransactions);
//         setFilteredTransactions(fetchedTransactions);

//         // Calculate total amount for all transactions initially
//         const total = fetchedTransactions.reduce(
//           (sum, transaction) => sum + (Number(transaction.amount) || 0),
//           0
//         );
//         setTotalAmount(total);
//       } catch (err) {
//         setError(err.response?.data?.message || "Failed to fetch transactions.");
//       }
//     };

//     fetchTransactions();
//   }, []);

//   useEffect(() => {
//     // Filter transactions safely, checking for null values
//     const filteredData = transactions.filter((transaction) =>
//       (transaction.payment_type ? transaction.payment_type.toLowerCase() : "").includes(searchPaymentType.toLowerCase()) &&
//       (transaction.storename ? transaction.storename.toLowerCase() : "").includes(searchStoreName.toLowerCase())
//     );

//     setFilteredTransactions(filteredData);

//     // Recalculate the total amount for filtered transactions
//     const filteredTotal = filteredData.reduce(
//       (sum, transaction) => sum + (Number(transaction.amount) || 0),
//       0
//     );
//     setFilteredTotalAmount(filteredTotal);
//   }, [searchPaymentType, searchStoreName, transactions]);

//   const columns = [
//     { name: "Transaction Date", selector: (row) => new Date(row.transaction_date).toLocaleDateString(), sortable: true },
//     { 
//       name: "Store Name", 
//       selector: (row) => (
//         <div>
//           {row.storename}
//           <br />
//           <small>({row.storeid})</small>
//         </div>
//       ), 
//       sortable: true 
//     },
//     { name: "Currency", selector: (row) => row.currency_type || "-", sortable: true },
//     { name: "Cash in Type", selector: (row) => row.cash_in_type || "-", sortable: true },
//     { name: "Payment Type", selector: (row) => row.payment_type, sortable: true },
//     { name: "Cheque Number", selector: (row) => (row.payment_type === "cheque" ? row.check_number : "-") },
//     { name: "Amount", selector: (row) => row.amount, sortable: true },
//     {
//       name: "File",
//       selector: (row) =>
//         row.file ? (
//           <a href={row.file} target="_blank" rel="noopener noreferrer">
//             View File
//           </a>
//         ) : (
//           "-"
//         ),
//     },
//   ];

//   // Function to export data to Excel
//   const exportToExcel = (data, filename, totalAmount) => {
//     const formattedData = data.map(({ id, file, ...rest }) => ({
//       "Transaction Date": new Date(rest.transaction_date).toLocaleDateString(),
//       "Store Name": rest.storename,
//       "Store ID": rest.storeid, // Added Store ID
//       "Currency": rest.currency_type || "-",
//       "Cash in Type": rest.cash_in_type || "-",
//       "Payment Type": rest.payment_type || "-",
//       "Cheque Number": rest.payment_type === "cheque" ? rest.check_number : "-",
//       "Amount": Number(rest.amount) || 0,
//     }));
  
//     // Add total amount row
//     formattedData.push({
//       "Transaction Date": "",
//       "Store Name": "",
//       "Store ID": "",
//       "Currency": "",
//       "Cash in Type": "",
//       "Payment Type": "Total Amount",
//       "Cheque Number": "",
//       "Amount": totalAmount.toFixed(2),
//     });
  
//     const worksheet = XLSX.utils.json_to_sheet(formattedData);
  
//     // Adjust column widths for better readability
//     worksheet['!cols'] = [
//       { wch: 15 }, // Transaction Date
//       { wch: 35 }, // Store Name
//       { wch: 10 }, // Store ID
//       { wch: 10 }, // Currency
//       { wch: 15 }, // Cash in Type
//       { wch: 15 }, // Payment Type
//       { wch: 15 }, // Cheque Number
//       { wch: 12 }  // Amount
//     ];
  
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Transactions");
  
//     // Save file
//     XLSX.writeFile(workbook, `${filename}.xlsx`);
//   };
  
  

//   return (
//     <div>
//       <Header />

//       <div className="container mt-5">
//         <h1 className="text-center mb-4">Transactions Details</h1>

//         <div className="d-flex justify-content-between mb-4">
//           <button className="btn btn-primary" onClick={() => navigate("/addtransactions")}>
//             Add Transaction
//           </button>
//           <div>
//             <button
//               className="btn btn-success me-2"
//               onClick={() => exportToExcel(transactions, "All_Transactions", totalAmount)}
//             >
//               Export All to Excel
//             </button>
//             <button
//               className="btn btn-warning"
//               onClick={() => exportToExcel(filteredTransactions, "Filtered_Transactions", filteredTotalAmount)}
//               disabled={filteredTransactions.length === 0}
//             >
//               Export Filtered to Excel
//             </button>
//           </div>
//         </div>

//         {error && <div className="alert alert-danger">{error}</div>}

//         <div className="row mb-3">
//           <div className="col-md-6">
//             <input
//               type="text"
//               className="form-control"
//               placeholder="Search by payment type..."
//               value={searchPaymentType}
//               onChange={(e) => setSearchPaymentType(e.target.value)}
//             />
//           </div>
//           <div className="col-md-6">
//             <input
//               type="text"
//               className="form-control"
//               placeholder="Search by store name..."
//               value={searchStoreName}
//               onChange={(e) => setSearchStoreName(e.target.value)}
//             />
//           </div>
//         </div>

//         <DataTable
//           columns={columns}
//           data={filteredTransactions}
//           pagination
//           highlightOnHover
//           striped
//           responsive
//         />

//         {transactions.length > 0 && (
//           <div className="d-flex justify-content-between mt-3">
//             <h5>Total Amount: {totalAmount.toFixed(2)}</h5>
//             {filteredTransactions.length > 0 && <h5>Filtered Total Amount: {filteredTotalAmount.toFixed(2)}</h5>}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default Home;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";
import Header from "../components/Header";
import { motion } from "framer-motion"; // <-- motion import

function Home() {
  const navigate = useNavigate();
  const [transactions, setTransactions] = useState([]);
  const [error, setError] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const [filteredTotalAmount, setFilteredTotalAmount] = useState(0);
  const [searchPaymentType, setSearchPaymentType] = useState("");
  const [searchStoreName, setSearchStoreName] = useState("");
  const [filteredTransactions, setFilteredTransactions] = useState([]);

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const token = localStorage.getItem("accessToken");
        const response = await axios.get("/user/getTransactions", {
          headers: { Authorization: `Bearer ${token}` },
        });

        const fetchedTransactions = response.data.transactions || [];
        setTransactions(fetchedTransactions);
        setFilteredTransactions(fetchedTransactions);

        const total = fetchedTransactions.reduce(
          (sum, transaction) => sum + (Number(transaction.amount) || 0),
          0
        );
        setTotalAmount(total);
      } catch (err) {
        setError(err.response?.data?.message || "Failed to fetch transactions.");
      }
    };

    fetchTransactions();
  }, []);

  useEffect(() => {
    const filteredData = transactions.filter((transaction) =>
      (transaction.payment_type ? transaction.payment_type.toLowerCase() : "").includes(searchPaymentType.toLowerCase()) &&
      (transaction.storename ? transaction.storename.toLowerCase() : "").includes(searchStoreName.toLowerCase())
    );

    setFilteredTransactions(filteredData);

    const filteredTotal = filteredData.reduce(
      (sum, transaction) => sum + (Number(transaction.amount) || 0),
      0
    );
    setFilteredTotalAmount(filteredTotal);
  }, [searchPaymentType, searchStoreName, transactions]);

  const columns = [
    { name: "Transaction Date", selector: (row) => new Date(row.transaction_date).toLocaleDateString(), sortable: true },
    { 
      name: "Store Name", 
      selector: (row) => (
        <div>
          {row.storename}
          <br />
          <small>({row.storeid})</small>
        </div>
      ), 
      sortable: true 
    },
    { name: "Currency", selector: (row) => row.currency_type || "-", sortable: true },
    { name: "Cash in Type", selector: (row) => row.cash_in_type || "-", sortable: true },
    { name: "Payment Type", selector: (row) => row.payment_type, sortable: true },
    { name: "Cheque Number", selector: (row) => (row.payment_type === "cheque" ? row.check_number : "-") },
    { name: "Amount", selector: (row) => row.amount, sortable: true },
    {
      name: "File",
      selector: (row) =>
        row.file ? (
          <a href={row.file} target="_blank" rel="noopener noreferrer">
            View File
          </a>
        ) : (
          "-"
        ),
    },
  ];

  const exportToExcel = (data, filename, totalAmount) => {
    const formattedData = data.map(({ id, file, ...rest }) => ({
      "Transaction Date": new Date(rest.transaction_date).toLocaleDateString(),
      "Store Name": rest.storename,
      "Store ID": rest.storeid,
      "Currency": rest.currency_type || "-",
      "Cash in Type": rest.cash_in_type || "-",
      "Payment Type": rest.payment_type || "-",
      "Cheque Number": rest.payment_type === "cheque" ? rest.check_number : "-",
      "Amount": Number(rest.amount) || 0,
    }));

    formattedData.push({
      "Transaction Date": "",
      "Store Name": "",
      "Store ID": "",
      "Currency": "",
      "Cash in Type": "",
      "Payment Type": "Total Amount",
      "Cheque Number": "",
      "Amount": totalAmount.toFixed(2),
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    worksheet['!cols'] = [
      { wch: 15 },
      { wch: 35 },
      { wch: 10 },
      { wch: 10 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 12 },
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Transactions");
    XLSX.writeFile(workbook, `${filename}.xlsx`);
  };

  return (
    <div>
      <Header />

      <div className="container mt-5">
        <motion.h1
          className="text-center mb-4"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Transactions Details
        </motion.h1>

        <motion.div
          className="d-flex justify-content-between mb-4"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          <button className="btn btn-primary" onClick={() => navigate("/addtransactions")}>
            Add Transaction
          </button>
          <div>
            <button
              className="btn btn-success me-2"
              onClick={() => exportToExcel(transactions, "All_Transactions", totalAmount)}
            >
              Export All to Excel
            </button>
            <button
              className="btn btn-warning"
              onClick={() => exportToExcel(filteredTransactions, "Filtered_Transactions", filteredTotalAmount)}
              disabled={filteredTransactions.length === 0}
            >
              Export Filtered to Excel
            </button>
          </div>
        </motion.div>

        {error && <div className="alert alert-danger">{error}</div>}

        <motion.div
          className="row mb-3"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          <div className="col-md-6">
            <input
              type="text"
              className="form-control"
              placeholder="Search by payment type..."
              value={searchPaymentType}
              onChange={(e) => setSearchPaymentType(e.target.value)}
            />
          </div>
          <div className="col-md-6">
            <input
              type="text"
              className="form-control"
              placeholder="Search by store name..."
              value={searchStoreName}
              onChange={(e) => setSearchStoreName(e.target.value)}
            />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.6 }}
        >
          <DataTable
            columns={columns}
            data={filteredTransactions}
            pagination
            highlightOnHover
            striped
            responsive
          />
        </motion.div>

        {transactions.length > 0 && (
          <motion.div
            className="d-flex justify-content-between mt-3"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.5 }}
          >
            <h5>Total Amount: {totalAmount.toFixed(2)}</h5>
            {filteredTransactions.length > 0 && (
              <h5>Filtered Total Amount: {filteredTotalAmount.toFixed(2)}</h5>
            )}
          </motion.div>
        )}
      </div>
    </div>
  );
}

export default Home;
